<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
      <onaydialog ref="onaydialog"></onaydialog>

    <v-form>
      <v-card color="grey lighten-5">
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont"> {{$t('Bank-Pos-Login-Screen')}} </v-toolbar-title>
              <v-spacer></v-spacer>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update" v-if="taksitbtn" slot="activator" @click="Guncelle()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                  </span>
                  <v-icon right dark>create</v-icon>

                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" v-if="kaydetbtn" slot="activator" @click="Kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>
                  <v-icon right dark>add_box</v-icon>

                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>

              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-tooltip bottom>
                    <v-list-tile slot="activator" :disabled="!sayfayetki.Delete" @click="bankapossil()">
                      <v-list-tile-title>{{ $t('Delete') }}</v-list-tile-title>
                    </v-list-tile>
                    <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                    <span v-if="sayfayetki.Delete"> {{ $t('Delete') }} </span>
                  </v-tooltip>

                  <v-list-tile @click="TaksitEkle()" v-if="taksitbtn">
                    <v-list-tile-title>Taksit Girişi</v-list-tile-title>
                  </v-list-tile>
                  <a target="_self" v-bind:href="'#/parametreler/genel/bankapos'">
                    <v-list-tile>
                      <v-list-tile-title>{{$t("cancel_button")}}</v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
              </v-menu>

            </v-toolbar>
          </v-flex>

          <v-layout row wrap>

            <v-flex pa-1 xs12 sm6 md3>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>

                    <v-layout justify-space-between column>
                      <v-flex xs12 sm12 pt-1 pb-2 md12>
                        <v-layout row wrap class=" project overdue">
                          <v-toolbar flat="" size="100px" dark color="white">
                            <v-toolbar-title>
                              <span class="title black--text font-weight-">
                                {{ $t('Options-v2') }}
                              </span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </v-layout>
                      </v-flex>
                      <v-text-field :disabled="diskode =='1'" hide-details="" :label="$t('Bank-Pos-Code')"
                        v-model="BankaPos.PosCode" :error-messages="errors.collect('poscode')"
                        v-validate="'required|max:4'" data-vv-name="poscode" required>
                      </v-text-field>



                      <v-text-field hide-details="" :label="$t('Description')" v-model="BankaPos.Explaniton"
                        :error-messages="errors.collect('posaciklama')" v-validate="'required'"
                        data-vv-name="posaciklama" required>
                      </v-text-field>


                      <v-select :items="BankList" hide-details="" clearable v-bind="BankList" item-text="BankaAdi"
                        item-value="BankaKod" v-model="BankaPos.Parameters.Banka.BankaKod" :label="$t('Bank-Code')">
                      </v-select>


                      <cariaracomp  v-bind:etiket="$t('Select-Pos-Current-Code')" v-bind:value="BankaPos.Parameters.PosMuhKodu"
                       v-model="BankaPos.Parameters.PosMuhKodu" v-bind:statecariyedek="statecari" :Coper="false"></cariaracomp>

                      <cariaracomp   v-bind:etiket="$t('Select-Point-Current-Code')" v-bind:value="BankaPos.Parameters.PuanCariKodu"
                       v-model="BankaPos.Parameters.PuanCariKodu" v-bind:statecariyedek="statecari" :Coper="false"></cariaracomp>


                      <v-menu :close-on-content-click="true" v-model="menu" transition="scale-transition" offset-y
                        full-width :nudge-right="40" min-width="290px">
                        <v-text-field hide-details="" slot="activator" label="Söz.Baş.Tar." v-model="dateFormatted"
                          append-icon="event" v-on:change="onChange" mask="##.##.####"
                          @blur="date = parseDate(dateFormatted)"></v-text-field>
                        <v-date-picker locale="tr" v-model="date" @input="dateFormatted = formatDate($event)" no-title
                          scrollable actions>
                          <v-spacer></v-spacer>
                        </v-date-picker>
                      </v-menu>


                      <v-menu :close-on-content-click="true" v-model="menu2" transition="scale-transition" offset-y
                        full-width :nudge-right="40" min-width="290px">
                        <v-text-field slot="activator" hide-details="" label="Söz.Bit.Tar." v-model="dateFormatted2"
                          append-icon="event" v-on:change="onChange2" mask="##.##.####"
                          @blur="date2 = parseDate2(dateFormatted2)"></v-text-field>
                        <v-date-picker locale="tr" v-model="date2" @input="dateFormatted2 = formatDate2($event)"
                          no-title scrollable actions>
                          <v-spacer></v-spacer>
                        </v-date-picker>
                      </v-menu>

                      <parainput :simge="getparabirimi()" :etiket="$t('Membership-Fee')"
                        v-model="BankaPos.Parameters.UyelikTutar" :autocomplete="'autocomplete'"></parainput>

                      <yuzdeinput :etiket="$t('Membership-Percentage')" v-model="BankaPos.Parameters.UyelikOran"
                        :autocomplete="'autocomplete'"></yuzdeinput>

                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>


            <v-flex pa-1 xs12 sm6 md3>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <v-flex xs12 sm12 pt-1 pb-2 md12>
                        <v-layout row wrap class=" project overdue">
                          <v-toolbar flat="" size="100px" dark color="white">
                            <v-toolbar-title>
                              <span class="title black--text font-weight-">
                                {{ $t('Accounting-Code') }}
                              </span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </v-layout>
                      </v-flex>



                      <muhasebekoducomp v-model="BankaPos.MuhasebeKodlar.MuhasebeKodu"
                        :etiket="$t('Card-Creditor-Acc-Code')"></muhasebekoducomp>

                      <muhasebekoducomp v-model="BankaPos.MuhasebeKodlar.CMuhasebeKodu"
                        :etiket="$t('Card-Creditor-Acc-Code-C')"></muhasebekoducomp>


                      <v-text-field hide-details="" :label="$t('Card-Extract-Transfer-Current-Code')"
                        v-model="BankaPos.MuhasebeKodlar.FDisAktarimCariKodu">
                      </v-text-field>


                      <v-text-field hide-details="" :label="$t('Card-Extract-Transfer-Accounting-Code')"
                        v-model="BankaPos.MuhasebeKodlar.FDisAktarimMuhKodu"></v-text-field>

                      <v-text-field hide-details="" :label="$t('Card-Extract-Transfer-Current-Code-C')"
                        v-model="BankaPos.MuhasebeKodlar.CDisAktarimCariKodu"></v-text-field>


                      <v-text-field hide-details="" :label="$t('Card-Extract-Transfer-Accounting-Code-C')"
                        v-model="BankaPos.MuhasebeKodlar.CDisAktarimMuhKodu"></v-text-field>



                      <muhasebekoducomp v-model="BankaPos.MuhasebeKodlar.ServisMuhasebeKodu"
                        :etiket="$t('Service-Accounting-Code')"></muhasebekoducomp>



                      <v-text-field hide-details="" :label="$t('Service-Extract-Transfer-Current-Code')"
                        v-model="BankaPos.MuhasebeKodlar.ServisDisAktarimCariKodu"></v-text-field>


                      <v-text-field hide-details="" :label="$t('Service-Extract-Transfer-Accounting-Code')"
                        v-model="BankaPos.MuhasebeKodlar.ServisDisAktarimMuhKodu"></v-text-field>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>


            <v-flex pa-1 xs12 sm6 md3>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>

                    <v-layout justify-space-between column>

                      <v-flex xs12 sm12 pt-1 pb-2 md12>
                        <v-layout row wrap class=" project overdue">
                          <v-toolbar flat="" size="100px" dark color="white">
                            <v-toolbar-title>
                              <span class="title black--text font-weight-">
                                {{ $t('Quota-Details') }}
                              </span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </v-layout>
                      </v-flex>
                      <v-text-field :label="$t('Quota')" hide-details="" v-model="BankaPos.Parameters.Kota">
                      </v-text-field>
                      <v-layout>

                        <parainput :simge="getparabirimi()" :etiket="$t('Quota-Penalty-Fees')"
                          v-model="BankaPos.Parameters.KotaCezaTutar" :autocomplete="'autocomplete'"></parainput>

                        <yuzdeinput :etiket="$t('Percentage-v2')" v-model="BankaPos.Parameters.KotaCezaOran"
                          :autocomplete="'autocomplete'"></yuzdeinput>

                      </v-layout>


                      <v-text-field hide-details="" :label="$t('Quota-Day')" v-model="BankaPos.Parameters.KotaGun">
                      </v-text-field>
                      <v-flex xs12 sm12 pt-2 pb-2 md12>
                        <v-layout row wrap class=" project overdue">
                          <v-toolbar flat="" size="100px" dark color="white">
                            <v-toolbar-title>
                              <span class="title black--text font-weight-">
                                 {{ $t('Pos-Details') }}
                              </span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </v-layout>
                      </v-flex>

                      <v-text-field hide-details="" label="Terminal ID" v-model="BankaPos.Parameters.TerminalID">
                      </v-text-field>


                      <v-text-field hide-details="" :label="$t('Workplace-ID')" v-model="BankaPos.Parameters.UyeIsYeriID">
                      </v-text-field>

                      <v-text-field hide-details="" :label="$t('Username')" v-model="BankaPos.Parameters.UserName">
                      </v-text-field>

                      <v-text-field hide-details="" :label="$t('Password')" v-model="BankaPos.Parameters.UserPass">
                      </v-text-field>

                      <v-text-field hide-details="" :label="$t('Store-Key')" v-model="BankaPos.Parameters.StoreKey">
                      </v-text-field>
                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <v-flex pa-1 xs12 sm6 md3>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <v-flex xs12 sm12 pt-1 pb-2 md12>
                        <v-layout row wrap class=" project overdue">
                          <v-toolbar flat="" size="100px" dark color="white">
                            <v-toolbar-title>
                              <span class="title black--text font-weight-">
                                {{ $t('Term-Options') }}
                              </span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </v-layout>
                      </v-flex>
                      <v-radio-group v-model="BankaPos.Parameters.VadeTip" hide-details="" column>
                        <v-layout>
                          <v-flex xs12 sm6 md6>
                            <v-radio :label="$t('Next-Day-Term-Difference')" value="0"> </v-radio>
                          </v-flex>
                          <v-flex xs12 sm1 md1>
                            <v-card flat color="white">
                              <input width="20px" v-model="BankaPos.Parameters.VadeFarkSabit" type="text">
                            </v-card>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs12 sm6 md6>
                            <v-radio :label="$t('Fixed-Day')" value="1"></v-radio>
                          </v-flex>
                          <v-flex xs12 sm1 md1>
                            <v-card flat color="white">
                              <input width="20px" v-model="BankaPos.Parameters.VadeSabitGun" type="text">
                            </v-card>
                          </v-flex>
                        </v-layout>
                        <v-radio :label="$t('Every-Installment-Next-Day-Due')" value="2"></v-radio>
                      </v-radio-group>
                      <v-flex xs12 sm12 pt-2 pb-2 md12>
                        <v-layout row wrap class=" project overdue">
                          <v-toolbar flat="" size="100px" dark color="white">
                            <v-toolbar-title>
                              <span class="title black--text font-weight-">
                                Pos Tipi
                              </span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </v-layout>
                      </v-flex>

                      <v-radio-group hide-details="" v-model="BankaPos.Parameters.PosType" column>
                        <v-radio :label="$t('Only-Normal')" value="0"> </v-radio>
                        <v-radio :label="$t('Only')+ '3D'" value="1"></v-radio>
                        <v-radio :label="$t('3D-and-Normal')" value="2"></v-radio>
                      </v-radio-group>
                      <v-switch :label="$t('Pos-Active')" v-model="posStatus" hide-details></v-switch>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>


          </v-layout>

          <v-layout v-if="taksitbtn" row wrap>
            <v-flex xs12 sm12 md12>
              <v-layout justify-space-between column>

                <v-flex xs12 sm12 pt-2 pl-2 pr-2 md12>
                  <v-layout row wrap class=" project overdue">
                    <v-toolbar flat="" size="100px" dark color="white">
                      <v-toolbar-title>
                        <span class="title black--text font-weight-">
                          {{ $t('Installment-List') }}
                        </span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm12 pl-2 pr-2 md12>
                  <v-card flat>

                    <v-data-table :headers="headers" :rows-per-page-items=[50,100] :items=" itemsTakistler"
                      :search="searcharama">
                      <template slot="items" slot-scope="props">
                        <tr item>
                          <td class="text-xs-left">{{ props.item.PosKod }}</td>
                          <td class="text-xs-left">{{ props.item.TaksitAciklama }}</td>
                          <td class="text-xs-center">{{ props.item.TaksitAdet }}</td>
                          <td class="text-xs-right">{{ props.item.VadeFarkTutar | moneyformat }}</td>
                          <td class="text-xs-right">{{ props.item.VadeFarkYuzde | moneyformat }}</td>
                          <td class="text-xs-right">{{ props.item.PuanTutar | moneyformat }}</td>
                          <td class="text-xs-right">{{ props.item.PuanYuzde | moneyformat }}</td>
                            <td class="justify-center layout px-0">
                  <v-icon small color="green" @click="taksitgetir(props.item.TaksitID,props.item.PosKod,props.item)">edit</v-icon>
                </td>
                        </tr>
                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="warning">
                         {{ $t('No-records-searched-for', { value: search3}) }} 
                      </v-alert>
                    </v-data-table>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card>
    </v-form>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>

    <v-dialog v-model="dialog" persistent max-width="450px">
      <v-card flat color="grey lighten-5">
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
          </v-toolbar>
        </v-flex>
        <v-card-text>

          <v-layout row wrap>
            <v-flex pa-1 xs12 sm12 md12>
              <v-card flat>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <div v-show="codegorunum === true ">
                        <v-text-field hide-details :label="$t('Bank-Pos-Code')" v-model="Taksit.PosCode" disabled>
                        </v-text-field>
                      </div>
                      <v-text-field hide-details :label="$t('Description')" v-model="Taksit.InsExplanation"> </v-text-field>
                      <v-text-field hide-details mask="##" label="Taksit  Sayısı" v-model="Taksit.InsNumber">
                      </v-text-field>
                      <v-layout row wrap>

                        <v-flex xs12 md6 sm6>
                          <parainput :simge="getparabirimi()" :etiket="$t('Delay-interest')" v-model="Taksit.ExpiryDifAmount"
                            :autocomplete="'autocomplete'"></parainput>
                        </v-flex>
                        <v-flex xs12 md6 sm6>
                          <yuzdeinput :etiket="$t('Percentage-v2')" v-model="Taksit.ExpiryDifPercent"
                            :autocomplete="'autocomplete'"></yuzdeinput>
                        </v-flex>

                        <v-flex xs12 md6 sm6>
                          <parainput :simge="getparabirimi()" :etiket="$t('Point')" v-model="Taksit.PointAmount"
                            :autocomplete="'autocomplete'"></parainput>
                        </v-flex>

                        <v-flex xs12 md6 sm6>
                          <yuzdeinput :etiket="$t('Percentage-v2')" v-model="Taksit.PointPercent"
                            :autocomplete="'autocomplete'"></yuzdeinput>
                        </v-flex>

                        <v-flex xs12 md6 sm6>
                          <parainput :simge="getparabirimi()" :etiket="$t('Late-Interest-Sale')"
                            v-model="Taksit.ExpiryDifAmountSales" :autocomplete="'autocomplete'"></parainput>
                        </v-flex>

                        <v-flex xs12 md6 sm6>
                          <yuzdeinput :etiket="$t('Percentage-v2')" v-model="Taksit.ExpiryDifPercentSales"
                            :autocomplete="'autocomplete'"></yuzdeinput>
                        </v-flex>

                        <v-flex xs12 md6 sm6>
                          <parainput :simge="getparabirimi()" :etiket="$t('Score-Sale')" v-model="Taksit.PointAmountSales"
                            :autocomplete="'autocomplete'"></parainput>
                        </v-flex>

                        <v-flex xs12 md6 sm6>
                          <yuzdeinput :etiket="$t('Percentage-v2')" v-model="Taksit.PointPercentSales"
                            :autocomplete="'autocomplete'"></yuzdeinput>
                        </v-flex>

                      </v-layout>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" flat @click="vazgec()">{{$t('Cancel')}}</v-btn>
          <div v-show="m === true">
            <v-btn color="blue darken-1" flat @click="taksitsil()">{{ $t('Delete') }}</v-btn>
            <v-btn color="blue darken-1" flat @click="TaksitGuncelle()">{{ $t('Update') }}</v-btn>
          </div>
          <div v-show="k === true">
            <v-btn id="bkaydet" color="blue darken-1" flat @click="Taksitkaydet()">{{ $t('Add-v2', { value: $t('Instalment')}) }} </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import '../../../assets/css/custom.css'
  import parainput from '../customcomp/parainput'
  import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import muhasebekoducomp from '@/components/app/customcomp/muhasebekoducomp.vue'
  import onaydialog from "@/components/app/customcomp/onaydialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'

  export default {

    props: {
      operation: ''
    },

    data() {
      return {
        posStatus:false,
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        headers: [
          {
            text: 'Pos Kod',
            value: 'PosKod'
          },
          {
            text: this.$t('Description'),
            value: 'TaksitAciklama'
          },
          {
            text: 'Taksit Adet',
            value: 'TaksitAdet',
            align:'center'
          },
          {
            text: this.$t('Late-Interest-Amount'),
            value: 'VadeFarkTutar',
            align: 'right'
          },
          {
            text: this.$t('Late-Interest-Percentage'),
            value: 'VadeFarkYuzde',
            align: 'right'
          },
          {
            text: this.$t('Point') + ' ( ' +  this.$t('Amount') +')',
            value: 'PuanTutar',
            align: 'right'
          },
          {
            text: this.$t('Point') + ' (Yüzde)',
            value: 'PuanYuzde',
            align: 'right'
          },
          {
            text: '',
            value: '',

          }
        ],
        drawer: null,
        color: 'orange darken-4',
        switch1: true,
        baslik: '',
        itemsTakistler: [],
        dialog: false,
        dialog_baslik: '',
        e1: 0,
        Code: '',
        e2: true,
        loading: false,
        search: '',
        searcharama: '',
        search1: '',
        karsicari: true,
        codegorunum: true,
        diskode: '0',
        m: false,
        k: false,
        BankaPos: {
          BankaPosID: '',
          CompanyCode: '',
          PosCode: '',
          Explaniton: '',
          Codes: '',
          Amount: '',
          MuhasebeKodlar: {
            MuhasebeKodu: '',
            CMuhasebeKodu: '',
            FDisAktarimCariKodu: '',
            FDisAktarimMuhKodu: '',
            CDisAktarimCariKodu: '',
            CDisAktarimMuhKodu: '',
            ServisMuhasebeKodu: '',
            ServisDisAktarimCariKodu: '',
            ServisDisAktarimMuhKodu: ''
          },
          Parameters: {
            Banka: {
              BankaKod: '',
            },
            ID: '',
            PosMuhKodu: '',
            PuanCariKodu: '',
            SozlesmeBaslangic: '',
            SozlesmeBitis: '',
            Aktif: '',
            VadeTip: '',
            UyelikTutar: 0,
            UyelikOran: 0,
            Kota: '',
            KotaGun: '',
            KotaCezaTutar: 0,
            KotaCezaOran: 0,
            VadeSabitGun: '0',
            VadeFarkSabit: '1',
            KotaKod: '',
            TerminalID: '',
            UyeIsYeriID: '',
            UserName: '',
            UserPass: '',
            PosType: '',
            StoreKey: ''
          },
        },
        Taksit: {
          InsID: null,
          CompanyCode: null,
          PosCode: null,
          InsExplanation: 0,
          InsNumber: 0,
          ExpiryDifPercent: 0,
          ExpiryDifAmount: 0,
          PointPercent: 0,
          PointAmount: 0,
          ExpiryDifPercentSales: 0,
          ExpiryDifAmountSales: 0,
          PointPercentSales: 0,
          PointAmountSales: 0
        },
        BankList: [],
        statecari: [],
        statecari2: [],
        taksitbtn: false,
        kaydetbtn: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        text1: '',
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        urlyedek: '',
        dictionary: {
          custom: {
            poscode: {
              required: () => this.$t('This-space-cannot-left-blank'),
              max: () => 'En fazla 4 karakterden oluşmalıdır'
            },
            uyelikoran: {
              min: () => this.$t('Please-fill-with-etc-format')
            },
            posaciklama: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            taksitaciklama: {
              required: () => this.$t('This-space-cannot-left-blank')
            },

          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));



        this.urlyedek = '#' + String(this.$route.fullPath)
        if (this.$route.params.id == 'yeni') {
          this.taksitbtn = false
          this.kaydetbtn = true
        } else if (this.$route.params.id != 'yeni' && this.$route.params.id != null) {
          this.taksitbtn = true
          this.kaydetbtn = false


          var params1 = {
            CompanyCode: credentials.SirketKodu,
            PosCode: this.$route.params.id
          }

          this.$http.post(auth.API_URL + 'api/BankPos/Get', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.diskode = '1'
            this.itemsTakistler = response.body.Taksitler
            this.BankaPos.PosCode = response.body.PosKodu
            this.Taksit.PosCode = response.body.PosKodu
            this.BankaPos.BankaPosID = response.body.BankaPosID
            this.BankaPos.Explaniton = response.body.Aciklama
            this.BankaPos.MuhasebeKodlar = response.body.MuhasebeKodlar
            if (response.body.Parametreler.Banka != null) {
              this.BankaPos.Parameters = response.body.Parametreler
            } else {
              var gelen = response.body.Parametreler
              var yeni = {
                BankaKod: null
              }
              gelen.Banka = yeni
              this.BankaPos.Parameters = gelen
            }
            var bastarih = response.body.Parametreler.SozlesmeBaslangic.split("T")

            if (String(bastarih[0]) === '0001-01-01') {
              this.BankaPos.Parameters.SozlesmeBaslangic = null
            } else {
              this.BankaPos.Parameters.SozlesmeBaslangic = response.body.Parametreler.SozlesmeBaslangic
              var partsvalue = response.body.Parametreler.SozlesmeBaslangic.split("T")
              this.date = partsvalue[0]
              this.dateFormatted = toDateformat(this.date)
            }
            var bittarih = response.body.Parametreler.SozlesmeBitis.split("T")
            if (String(bittarih[0]) === '0001-01-01') {
              this.BankaPos.Parameters.SozlesmeBitis = null
            } else {

              this.BankaPos.Parameters.SozlesmeBitis = response.body.Parametreler.SozlesmeBitis
              var partsvalue1 = response.body.Parametreler.SozlesmeBitis.split("T")
              this.date2 = partsvalue1[0]
              this.dateFormatted2 = toDateformat(this.date2)
            }
            if (response.body.Parametreler.Aktif == 1) {
              this.posStatus = true
            } else {
              this.posStatus = false
            }

            this.BankaPos.Parameters.PosType = String(response.body.Parametreler.PosType)

          }, (response) => {
          if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.body.ResponseMessage
            this.snacakbar = true
          }
          })
        }


        var paramsv1 = {
          CompanyCode: credentials.SirketKodu
        }
        this.$http.post(auth.API_URL + 'api/Bank/List', paramsv1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.BankList = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.body.ResponseMessage
            this.snacakbar = true
          }
        })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    methods: {
      getparabirimi() {
        return helpers.getparabirimi()
      },
      formatDate(date) {
        var str = date
        var n = str.search('.')
        if (n == 1) {
          return null
        } else {
          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },
      formatDate2(date) {
        var str = date
        var n = str.search('.')
        if (n == 1) {
          return null
        } else {
          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },
      parseDate(date) {
        if (!date) return null
        var str = date
        var n = str.search('-')
        var m = str.length
        if (n == 1) {
          const [month, day, year] = date.split('-')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        } else if (m == 8) {} else if (n == -1 && m != 8) {
          this.dateFormatted = getDateNow1()
          this.date = getDateNow()
        } else {
          const [day, month, year] = date.split('.')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
      },
      parseDate2(date) {
        if (!date) return null
        var str = date
        var n = str.search('-')
        var m = str.length
        if (n == 1) {
          const [month, day, year] = date.split('-')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        } else if (m == 8) {} else if (n == -1 && m != 8) {
          this.dateFormatted2 = getDateNow1()
          this.date2 = getDateNow()
        } else {
          const [day, month, year] = date.split('.')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
      },
      karsicariac: karsicariac,
      Kaydet: Kaydet,
      TaksitEkle: TaksitEkle,
      vazgec: vazgec,
      onChange: onChange,
      onChange2: onChange2,
      yuzdegoster: yuzdegoster,
      toDateformat: toDateformat,
      toDate: toDate,
      Guncelle: Guncelle,
      tarihkontrol: tarihkontrol,
      Taksitkaydet: Taksitkaydet,
      getir: getir,
      taksitgetir: taksitgetir,
      bankapossil: bankapossil,
      taksitsil: taksitsil,
      TaksitGuncelle: TaksitGuncelle
    },
    beforeMount: beforeMount,
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    components: {
      yetkidialog,
      parainput,
      muhasebekoducomp,
      yuzdeinput,
      onaydialog,
      cariaracomp
    },
    watch: {
    },
  }

  function bankapossil() {
    if (window.confirm('Banka Pos\'u silmek istediğinizden eminmisiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));


      var params = {
        CompanyCode: credentials.SirketKodu,
        PosCode: this.BankaPos.PosCode
      }

      this.$http.post(auth.API_URL + 'api/BankPos/Delete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.dialog = false
          this.text1 = response.body.ResponseMessage
          this.snackbar = true

        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true

        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = response.body.Status
          this.snackbar = true
        }
      })
    }
  }

  function taksitsil() {


 this.$refs.onaydialog.open('Bu taksiti silmek istediğinize emin misiniz?', 1).then(
          sonuc => {

            if (sonuc == true) {

            var credentials = JSON.parse(window.localStorage.getItem('credentials'));



      var params = {
        PosCode: this.Taksit.PosCode,
        CompanyID: credentials.SirketKodu,
        insId: this.Taksit.InsID,
      }

      this.$http.post(auth.API_URL + 'api/BankPos/InsDelete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.dialog = false
          this.text1 = response.body.ResponseMessage
          this.snackbar = true

          var paramsn = {
            InsID: '',
            CompanyID: credentials.SirketKodu,
            PosCode: this.BankaPos.PosCode
          }
          this.$http.post(auth.API_URL + 'api/BankPos/InsList', paramsn, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.itemsTakistler = response.body
          }, (response) => {
            if (response.Status === false) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            }
          })
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = response.body.Status
          this.snackbar = true
        }
      })

            }
          });


  }



  function getir(v) {
    this.k = false
    this.m = true
    this.codegorunum = false
    this.dialog = true
    this.dialog_baslik = 'Taksit Güncelle/Sil'
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));



    var params = {
      CompanyCode: credentials.SirketKodu,
      PosCode: v
    }
    this.$http.post(auth.API_URL + 'api/doctype/Get', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.Evrak.DocTypeCode = response.body[0].Evrakkod
      this.Evrak.DocTypeName = response.body[0].Aciklama
      this.select = response.body[0].BA.trim()
      this.Evrak.AccountDC = response.body[0].Cari
    })
  }

  function vazgec() {
    this.dialog = false

  }

  function TaksitEkle() {

    this.dialog = true
    this.k = true
    this.m=false
    this.dialog_baslik = 'Taksit Ekle'
    this.Taksit.InsID = null
    this.Taksit.CompanyCode = null
    this.Taksit.InsExplanation = null
    this.Taksit.InsNumber = 0
    this.Taksit.ExpiryDifPercent = 0
    this.Taksit.ExpiryDifAmount = 0
    this.Taksit.PointPercent = 0
    this.Taksit.PointAmount = 0
    this.Taksit.ExpiryDifPercentSales = 0
    this.Taksit.ExpiryDifAmountSales = 0
    this.Taksit.PointPercentSales = 0
    this.Taksit.PointAmountSales = 0
    this.Taksit.PosCode = this.BankaPos.PosCode
  }

  function Guncelle() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));




    if (this.posStatus == true) {
      this.BankaPos.Parameters.Aktif = '1'
    } else {
      this.BankaPos.Parameters.Aktif = '0'
    }

    if (this.BankaPos.Parameters.VadeTip == '0') {
      this.BankaPos.Parameters.VadeSabitGun = null

    } else if (this.BankaPos.Parameters.VadeTip == '1') {
      this.BankaPos.Parameters.VadeFarkSabit = null

    } else {
      this.BankaPos.Parameters.VadeSabitGun = null
      this.BankaPos.Parameters.VadeFarkSabit = null
    }



    this.BankaPos.Parameters.SozlesmeBaslangic = this.date
    this.BankaPos.Parameters.SozlesmeBitis = this.date2

    var params = {
      CompanyCode: credentials.SirketKodu,

      BankPosID: this.BankaPos.BankaPosID,

      PosCode: this.BankaPos.PosCode,

      Explaniton: this.BankaPos.Explaniton,

      Codes: this.BankaPos.MuhasebeKodlar,

      Parameters: this.BankaPos.Parameters
    }


    this.$http.post(auth.API_URL + 'api/BankPos/Update', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      if (response.body.Status === true) {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      } else {
        this.text1 = response.body.ResponseMessage

        this.snackbar = true
      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }


  function TaksitGuncelle() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));



    var params = {
      PosCode: this.Taksit.PosCode,
      CompanyCode: credentials.SirketKodu,
      InsID: this.Taksit.InsID,
      InsExplanation: this.Taksit.InsExplanation,
      InsNumber: this.Taksit.InsNumber,
      ExpiryDifPercent: this.Taksit.ExpiryDifPercent,
      ExpiryDifAmount: this.Taksit.ExpiryDifAmount,
      PointPercent: this.Taksit.PointPercent,
      PointAmount: this.Taksit.PointAmount,
      ExpiryDifAmountSales: this.Taksit.ExpiryDifAmountSales,
      ExpiryDifPercentSales: this.Taksit.ExpiryDifPercentSales,
      PointPercentSales: this.Taksit.PointPercentSales,
      PointAmountSales: this.Taksit.PointAmountSales,
    }
    this.$http.post(auth.API_URL + 'api/BankPos/InsUpdate', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      if (response.body.Status === true) {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.dialog = false

        var params1 = {
          CompanyID: credentials.SirketKodu,
          PosCode: this.Taksit.PosCode,
          InsID: ''
        }
        this.$http.post(auth.API_URL + 'api/BankPos/InsList', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.itemsTakistler = response.body

        }, (response) => {
          if (response.Status === false) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        })

      } else {
        this.text1 = response.body.ResponseMessage

        this.snackbar = true
      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }


  function Kaydet() {



    this.$validator.validateAll().then((result) => {

      if (result) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.BankaPos.Parameters.SozlesmeBaslangic = this.date
        this.BankaPos.Parameters.SozlesmeBitis = this.date2

        if (this.posStatus == true) {
          this.BankaPos.Parameters.Aktif = '1'
        } else {
          this.BankaPos.Parameters.Aktif = '0'
        }

        if (this.BankaPos.Parameters.VadeTip == '0') {
          this.BankaPos.Parameters.VadeSabitGun = null

        } else if (this.BankaPos.Parameters.VadeTip == '1') {
          this.BankaPos.Parameters.VadeFarkSabit = null

        } else {
          this.BankaPos.Parameters.VadeSabitGun = null
          this.BankaPos.Parameters.VadeFarkSabit = null
        }



        var params = {
          CompanyCode: credentials.SirketKodu,
          PosCode: this.BankaPos.PosCode,
          Explaniton: this.BankaPos.Explaniton,
          Codes: this.BankaPos.MuhasebeKodlar,
          Parameters: this.BankaPos.Parameters,
        }

        this.$http.post(auth.API_URL + 'api/BankPos/Add', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
        }, (response) => {
          if (response.Status === false) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        })
      }
    })
  }

  function Taksitkaydet() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    this.$validator.validateAll().then((result) => {

      if (result) {

        var params = {
          CompanyCode: credentials.SirketKodu,
          PosCode: this.BankaPos.PosCode,
          InsExplanation: this.Taksit.InsExplanation,
          InsNumber: this.Taksit.InsNumber,
          ExpiryDifPercent: this.Taksit.ExpiryDifPercent,
          ExpiryDifAmount: this.Taksit.ExpiryDifAmount,
          PointPercent: this.Taksit.PointPercent,
          PointAmount: this.Taksit.PointAmount,
          ExpiryDifPercentSales: this.Taksit.ExpiryDifPercentSales,
          ExpiryDifAmountSales: this.Taksit.ExpiryDifAmountSales,
          PointPercentSales: this.Taksit.PointPercentSales,
          PointAmountSales: this.Taksit.PointAmountSales
        }

        this.$http.post(auth.API_URL + 'api/BankPos/InsAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
          this.dialog = false

          var params1 = {
            CompanyID: credentials.SirketKodu,
            PosCode: this.Taksit.PosCode,
            InsID: null
          }

          this.$http.post(auth.API_URL + 'api/BankPos/InsList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.itemsTakistler = response.body

          }, (response) => {
            if (response.Status === false) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            }
          })

        }, (response) => {
          if (response.Status === false) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        })
      }
    })
  }

  function onChange(v) {
    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      var ay = a[2] + a[3]
      var gun = a[0] + a[1]
      var yil = a[4] + a[5] + a[6] + a[7]

      a = new Date(b)

      if (a instanceof Date && !isNaN(a.valueOf())) {
        //şubatın 29 çekmesin
        if (ay == '02' && yil % 10 != 0 && gun == '29') {

          b = yil + '-' + ay + '-' + '28'
          this.date = b
          this.dateFormatted = '28' + '-' + ay + '-' + yil
          //31 nisan
        } else if (ay == '04' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 haziran
        } else if (ay == '06' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 eylül
        } else if (ay == '09' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 kasım
        } else if (ay == '11' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil

        } else {
          this.date = b
        }
      } else {
        this.dateFormatted = null

      }
    } else {
      this.dateFormatted = null
    }
  }

  function onChange2(v) {
    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      var ay = a[2] + a[3]
      var gun = a[0] + a[1]
      var yil = a[4] + a[5] + a[6] + a[7]

      a = new Date(b)
      if (a instanceof Date && !isNaN(a.valueOf())) {
        //şubatın 29 çekmesi
        if (ay == '02' && yil % 10 != 0 && gun == '29') {

          b = yil + '-' + ay + '-' + '28'
          this.date2 = b
          this.dateFormatted2 = '28' + '-' + ay + '-' + yil
          //31 nisan
        } else if (ay == '04' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date2 = b
          this.dateFormatted2 = '30' + '-' + ay + '-' + yil
          //31 haziran
        } else if (ay == '06' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date2 = b
          this.dateFormatted2 = '30' + '-' + ay + '-' + yil
          //31 eylül
        } else if (ay == '09' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date2 = b
          this.dateFormatted2 = '30' + '-' + ay + '-' + yil
          //31 kasım
        } else if (ay == '11' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date2 = b
          this.dateFormatted2 = '30' + '-' + ay + '-' + yil

        } else {
          this.date2 = b
        }
      } else {
        this.dateFormatted2 = null
      }
    } else {
      this.dateFormatted2 = null
    }
  }

  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
  }

  function karsicariac() {
    if (this.karsicari === false) {
      this.karsicari = true
    } else {
      this.karsicari = false
    }
  }

 


  function yuzdegoster(v) {

    // tam değerli gelen
    var id = String(v).split('')
    var nokta = String(v).split('.')

    if (String(v).length == 5) {
      return id[0] + id[1] + '.' + id[3] + id[4]

      // tam sayı gelen
    } else if (String(v).length == 2) {
      return id[0] + id[1] + '.' + '0' + '0'
    }

    // 3 haneli gelen
    else if (String(v).length == 4) {
      if (String(nokta[0]).length == 2) {
        return nokta[0] + '.' + nokta[1] + '0'
      } else {
        return '0' + nokta[0] + '.' + nokta[1]
      }

      // 2 haneli gelen
    } else if (String(v).length == 3) {
      return '0' + nokta[0] + '.' + nokta[1] + '0'

    } else if (String(v).length == 1) {
      return '0' + id[0] + '.' + '0' + '0'
    } else {
      return null
    }
  }

  

  function toDateformat(dateStr) {
    var parts = dateStr.split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function toDate(dateStr) {
    var parts = dateStr[0].split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function tarihkontrol(v) {


    if (Object.prototype.toString.call(v) === "[object Date]") {
      return true
    } else {
      return false;
    }
  }

  function taksitgetir(y, z,value) {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));



    var params = {
      InsID: y,
      CompanyID: credentials.SirketKodu,
      PosCode: z
    }

    this.$http.post(auth.API_URL + 'api/BankPos/InsList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.dialog = true
      this.dialog_baslik = 'Taksit Düzenle'
      this.m = true
      this.k = false



      this.Taksit.PosCode = response.body[0].PosKod
      this.Taksit.InsID = response.body[0].TaksitID
      this.Taksit.InsExplanation = response.body[0].TaksitAciklama
      this.Taksit.InsNumber = response.body[0].TaksitAdet
      this.Taksit.ExpiryDifPercent = response.body[0].VadeFarkYuzde
      this.Taksit.ExpiryDifAmount = response.body[0].VadeFarkTutar
      this.Taksit.PointPercent = response.body[0].PuanYuzde
      this.Taksit.PointAmount = response.body[0].PuanTutar
      this.Taksit.ExpiryDifAmountSales = response.body[0].VadeFarkTutarSatis
      this.Taksit.ExpiryDifPercentSales = response.body[0].VadeFarkYuzdeSatis
      this.Taksit.PointPercentSales = response.body[0].PuanYuzdeSatis
      this.Taksit.PointAmountSales = response.body[0].PuanTutarSatis


    }, (response) => {
     if (response.status === 0) {
       this.text1 = response.body.ResponseMessage
       this.snackbar = true
     } else {
       this.text1 = response.body.ResponseMessage
       this.snacakbar = true
     }
    })

  }

  function beforeMount() {


  }
</script>

<style>
</style>